export class AppConstants {
    public static Google_Policy='https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes';
    public static Youtube_Terms = 'https://www.youtube.com/t/terms';
    public static Google_Privacy_Policy = 'https://policies.google.com/privacy';
    public static Google_Security_Settings = 'https://myaccount.google.com/connections?filters=3,4&hl=en';
}